
import React from 'react';
import { Card } from '../ui/card';
import { Zap, Target, Clock, Shield } from 'lucide-react';

const AIStatsSection: React.FC = () => {
  const stats = [{
    number: "10x",
    label: "Faster Discovery",
    icon: <Zap className="w-8 h-8 text-white" />
  }, {
    number: "95%",
    label: "Match Accuracy",
    icon: <Target className="w-8 h-8 text-white" />
  }, {
    number: "2min",
    label: "Average Search",
    icon: <Clock className="w-8 h-8 text-white" />
  }, {
    number: "100%",
    label: "Verified Listings",
    icon: <Shield className="w-8 h-8 text-white" />
  }];

  return (
    <section className="relative z-10 py-16 my-0 bg-[#ff3571]">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card 
              key={index} 
              className="bg-white/20 backdrop-blur-sm border border-white/30 p-6 text-center hover:bg-white/30 hover:border-white/40 transition-all duration-500 transform hover:scale-105 hover:-translate-y-1 shadow-lg animate-fade-in-stagger"
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="flex items-center justify-center mb-4 transform transition-transform duration-300 hover:scale-110">
                {stat.icon}
              </div>
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">
                {stat.number}
              </div>
              <div className="text-slate-300 text-sm md:text-base font-medium">
                {stat.label}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIStatsSection;
